import { wencesApi } from "@/api/wencesApi";

/**
 * Trackings del módulo FindTeu para los widgets. Los cuatro widgets de tracking usan
 * la misma lista: una sola petición cada 60 s aunque estén todos en el dashboard.
 */
const TTL_MS = 60 * 1000;
let cache = null;

export function getTrackings({ force = false } = {}) {
  if (!force && cache && Date.now() - cache.at < TTL_MS) return cache.promise;
  const promise = wencesApi
    .get("/api/gotrading/findteu/trackings")
    .then(({ data }) => (data && Array.isArray(data.data) ? data.data : []))
    .catch((e) => {
      cache = null;
      throw e;
    });
  cache = { at: Date.now(), promise };
  return promise;
}

export function invalidateTrackings() {
  cache = null;
}

const DAY = 24 * 60 * 60 * 1000;

/** Días desde hoy hasta una fecha YYYY-MM-DD (negativo = ya pasó). */
export function daysFromToday(ymd) {
  if (!ymd) return null;
  const [y, m, d] = String(ymd).slice(0, 10).split("-").map((x) => parseInt(x, 10));
  if (!y || !m || !d) return null;
  const now = new Date();
  const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
  return Math.round((Date.UTC(y, m - 1, d) - today) / DAY);
}

/**
 * Estado derivado (la naviera no lo trae): un solo valor por tracking, en este orden de
 * prioridad. Mismos criterios que la pantalla de tracking (hitos vencidos, error de
 * sincronización, contenedor completado).
 */
export function trackingState(t) {
  if (t.isActive === false) return "stopped";
  if (t.completed) return "completed";
  if (t.lastSyncError && t.lastSyncError.code != null) return "error";
  const m = t.milestones || {};
  if (m.overdue || m.etaOverdue) return "delayed";
  const etdIn = daysFromToday(t.etd);
  if (etdIn !== null && etdIn > 0 && !m.lastActual) return "notSailed";
  if (!t.eta && !t.etd && !t.containerCount) return "noData";
  return "inTransit";
}

export const TRACKING_STATES = ["inTransit", "notSailed", "delayed", "error", "completed", "noData"];

export function trackingLink(t) {
  const q = new URLSearchParams({ trackingNumber: t.trackingNumber, trackingType: t.trackingType || "container", open: "1" });
  return `/ft/container-tracking?${q.toString()}`;
}
